---
title: The Octopus Organization
date: '2025-11-21'
excerpt: Neues aus der Welt der Organisationsentwicklung - Im neuesten Buch diskutieren Jana Werner und Phil Le-Brun die „Octopus Organization" als Gegenmodell zu klassischen Managementlogiken.

metaTitle: Octopus Organization - Neues aus der Organisationsentwicklung | Kevin Rassner
metaDescription: Jana Werner und Phil Le-Brun diskutieren die „Octopus Organization" als innovatives Gegenmodell zu klassischen Managementlogiken. Erfahren Sie, wie Organisationen Vertrauen und dezentrale Entscheidungsfreiheit als Erfolgsfaktoren verankern können.
language: de
slug: the-octopus-organization
author: Kevin Rassner
linkedinUrl: https://www.linkedin.com/feed/update/urn:li:activity:7397536786501193728/
isLinkedInPost: true
---

Neues aus der Welt der Organisationsentwicklung:

Im neuesten Buch diskutieren Jana Werner und Phil Le-Brun die „Octopus Organization" als Gegenmodell zu klassischen Managementlogiken. Sie argumentieren, dass Transformation nicht an Strategie oder Talent scheitert, sondern oft an tief verwurzelten Mustern, die Klarheit und Verantwortung untergraben. Neuartig ist, dass sie nicht nur Mindset, sondern konkrete Systeminterventionen empfehlen – etwa den Verzicht auf langwierige Genehmigungsprozesse zugunsten von Prinzipien-basierter Führung. Damit eröffnen sie eine Perspektive, wie Organisationen Vertrauen und dezentrale Entscheidungsfreiheit als Erfolgsfaktoren verankern können.

Besonderes Challenge für Manager: Lest euch mal die Überschriften (Antipattern) durch und behauptet weiter, dass ihr schon genug Organisationsentwicklung habt ;) https://lnkd.in/eKfNBXie

Wenn neue Artikel erscheinen, findet ihr sie bei mir! 3 mal pro Woche findet ihr hier alles Neue aus der spannenden Welt der Organisationsentwicklung.

